import { combineReducers } from 'redux';
import ceaseReducer from 'CustomerRequests/Cease/reducer';

const customerRequestsReducer = combineReducers({
  cease: ceaseReducer,
});

export default customerRequestsReducer;
